import { gql } from '@apollo/client';

export interface QaPreviewProject {
  id: number;
  name: string;
  createdDate: string;
  reports: { totalCount: number };
  containsReport: { totalCount: number };
}

export interface QaPreviewProjectsResponse {
  projects: { nodes: QaPreviewProject[] };
}

export default gql`
  query QaPreviewProjects($workspaceId: Int!, $reportId: UUID!) {
    projects: allProjects(
      filter: { workspaceId: { equalTo: $workspaceId } }
      orderBy: CREATED_DATE_DESC
    ) {
      nodes {
        id
        name
        createdDate
        reports: projectReportsByProjectId {
          totalCount
        }
        containsReport: projectReportsByProjectId(
          condition: { reportId: $reportId }
        ) {
          totalCount
        }
      }
    }
  }
`;
